import { Flex, Text, useInterval } from '@chakra-ui/react';
import { GridItemCentered } from './GridItemCentered';
import { Statistic } from '../../../components/PortfolioShared/Statistic';
import { Logger } from 'common/logger';
import { get, head, isNaN, toNumber } from 'lodash';
import { webSocketSendGetHistoricalProductionForecast } from 'common/webSocket.requests';
import { JOB_POWERGRIDS_HISTORY_INTERVAL } from 'common/constants';
import { useEffect } from 'react';
import { useRematchSelector } from 'models/rematchStore';

function isNumeric(num) {
    return !isNaN(num);
}
const calculatePercentage = (y1, y2) => {
    if (!isNumeric(y1) || !isNumeric(y2)) {
        Logger.warn(`y1: ${y1} or y2: ${y2} not a numeric`);
        return null;
    }

    if (toNumber(y1) === 0) {
        return 0;
    }

    return Math.round(((y2 - y1) / y1) * 100);
};

export const SubstationGridItems = ({ powerGrid, isLastItem, parkName }) => {
    const forecastHistory = useRematchSelector((state) =>
        get(state.parksData, `forecastHistoryById[${parkName}].[${powerGrid.entityKey}]`)
    );

    const activePower = powerGrid.active_power ? Number(powerGrid.active_power.value).toFixed(0) : null;
    const forecastPowerTemp = head(forecastHistory?.active_power?.values);
    const forecastPower = forecastPowerTemp ? Number(forecastPowerTemp)?.toFixed(0) : null;

    const unit = powerGrid.active_power?.unit || 'MW';

    const powerDiff = activePower - forecastPower;
    const powerPercent = calculatePercentage(forecastPower, activePower);

    const isAlert = Math.abs(powerPercent) >= 50;

    useEffect(() => {
        webSocketSendGetHistoricalProductionForecast(parkName, {
            entityKey: powerGrid.entityKey,
            precision: 'minute',
            count: 6 * 60,
        });
    }, [parkName, powerGrid.entityKey]);

    useInterval(() => {
        webSocketSendGetHistoricalProductionForecast(parkName, {
            entityKey: powerGrid.entityKey,
            precision: 'minute',
            count: 6 * 60,
        });
    }, JOB_POWERGRIDS_HISTORY_INTERVAL);

    return (
        <>
            <GridItemCentered borderBottomLeftRadius={isLastItem ? 4 : 0}>
                <Text fontWeight="bold" color="white">
                    {powerGrid.entityKey}
                </Text>
            </GridItemCentered>
            <GridItemCentered>
                <Statistic value={activePower} unit={unit} />
            </GridItemCentered>
            <GridItemCentered>
                <Statistic value={forecastPower} unit={unit} />
            </GridItemCentered>
            <GridItemCentered bg={isAlert ? 'redAlert' : 'grayDark2'} color={isAlert ? 'white' : 'black'}>
                <Flex width="100%">
                    <Statistic value={powerDiff} unit={unit} flex={1} justifyContent="flex-end" />
                    <Statistic value={powerPercent} unit="%" flex={1} justifyContent="flex-end" pr={3} />
                </Flex>
            </GridItemCentered>
        </>
    );
};
